import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/SimpleAuthContext';
import { useTheme } from '../contexts/ThemeContext';

function Navbar() {
  const { user, logout } = useAuth();
  const { isDarkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="border-b" style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--bg-color)' }}>
      <div className="container mx-auto px-6">
        <div className="flex justify-between items-center py-6">
          <div className="flex items-center gap-8">
            <Link to="/" className="text-lg font-bold" style={{ letterSpacing: '3px', color: 'var(--text-color)' }}>
              DIVVY
            </Link>
            <button
              onClick={toggleTheme}
              className="theme-toggle"
            >
              {isDarkMode ? 'LIGHT' : 'DARK'}
            </button>
          </div>
          
          <div className="flex items-center gap-0">
            {user ? (
              <>
                <Link to="/dashboard" className="tab-button">
                  DASHBOARD
                </Link>
                <Link to="/dividends" className="tab-button border-l-0">
                  DIVIDENDS
                </Link>
                <Link to="/token-locking" className="tab-button border-l-0">
                  LOCKING
                </Link>
                <Link to="/profile" className="tab-button border-l-0">
                  PROFILE
                </Link>
                <button
                  onClick={handleLogout}
                  className="tab-button border-l-0"
                >
                  LOGOUT
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="btn-minimal"
              >
                LOGIN
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;